
import { Component, Vue, Prop } from 'vue-property-decorator';
import { productNewList } from '@/api/device';
import { getFaultNewList } from '@/api/other';
import { UserModule } from '@/store/modules/user';

const fault = [{
  id: '1',
  name: '故障名称'
}, {
  id: '2',
  name: '故障类型'
}];
const phenomenon = [{
  id: '1',
  name: '故障现象名称'
}, {
  id: '2',
  name: '故障现象类型'
}];

@Component({
  name: 'OrderItemSearch'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false,
    required: true
  })
  isShowSearch!:Boolean

  @Prop({
    type: Number,
    default: '1',
    required: true
  })
  searchType!:Number

  @Prop({
    type: String,
    default: ''
  })
  companyId!: string;

  private searchForm: any = {
    item: '',
    name: ''
  }
  private nameList: any = []
  private tableData: any = []
  private selected = ''
  private searchShow: any = {
    isShow: this.isShowSearch
  }
  private modelMore=false;
  private page:number=1;

  private brandNameAlias=''
  private productNameAlias=''
  private modelNameAlias=''

  created() {
    if (UserModule.getCompany && UserModule.getCompany.alias_set) {
      this.brandNameAlias = UserModule.getCompany.alias_set.brand_name_alias;
      this.productNameAlias = UserModule.getCompany.alias_set.product_name_alias;
      this.modelNameAlias = UserModule.getCompany.alias_set.model_name_alias;
    }
    // 类型1 是 品牌， 2是故障类型， 3是故障现象
    if (this.searchType === 1) {
      this.nameList = [{
        id: '1',
        name: this.brandNameAlias ? this.brandNameAlias : '品牌'
      }, {
        id: '2',
        name: this.productNameAlias ? this.productNameAlias : '类型'
      }, {
        id: '3',
        name: this.modelNameAlias ? this.modelNameAlias : '型号'
      }];
    } else if (this.searchType === 2) {
      this.nameList = fault;
    } else if (this.searchType === 3) {
      this.nameList = phenomenon;
    }
  }

  // 搜品牌 只传回品牌
  // 搜类型 不用传参数，会覆盖掉之前的品牌
  // 搜型号 同样
  private searchHandle() {
    if (!this.searchForm.item.name) {
      this.showErrorMsg('请选择搜索项');
      return;
    }
    if (!this.searchForm.name) {
      this.showErrorMsg('请输入搜索项内容');
      return;
    }
    this.getList();
    this.searchShow.isShow = true;
    this.$emit('isSearch', this.searchShow.isShow);
  }
  private searchFormChange() {
    this.getList();
    this.searchShow.isShow = true;
    this.$emit('isSearch', this.searchShow.isShow);
  }

  private getList() {
    let params: any = {};
    params.company_id = this.companyId;
    params.name = this.searchForm.name;
    params.page = this.page;
    switch (this.searchType) {
      case 1:
        params.product_type = this.searchForm.item.id;
        productNewList(params)
          .then((res) => {
            if (res.data) {
              if (this.page === 1) {
                this.tableData = res.data.list;
              } else {
                this.tableData = this.tableData.concat(res.data.list);
              }

              if (this.page < parseInt(res.data.page_count)) {
                this.modelMore = true;
              } else {
                this.modelMore = false;
              }
            } else {
              this.modelMore = false;
              this.tableData = [];
            }
          })
          .catch((error) => {
            this.modelMore = false;
            let msg = error.msg;
          });
        break;
      case 2:
        params.type = 1;
        getFaultNewList(params).then((res) => {
          if (res.data) {
            if (this.page === 1) {
              this.tableData = res.data.list;
            } else {
              this.tableData = this.tableData.concat(res.data.list);
            }

            if (this.page < parseInt(res.data.page_count)) {
              this.modelMore = true;
            } else {
              this.modelMore = false;
            }
          } else {
            this.modelMore = false;
            this.tableData = [];
          }
        }).catch((error) => {
          this.modelMore = false;
          let msg = error.msg;
        });
        break;
      case 3:
        params.type = 2;
        getFaultNewList(params).then((res) => {
          if (res.data) {
            if (this.page === 1) {
              this.tableData = res.data.list;
            } else {
              this.tableData = this.tableData.concat(res.data.list);
            }

            if (this.page < parseInt(res.data.page_count)) {
              this.modelMore = true;
            } else {
              this.modelMore = false;
            }
          } else {
            this.modelMore = false;
            this.tableData = [];
          }
        }).catch((error) => {
          this.modelMore = false;
          let msg = error.msg;
        });
        break;
    }
  }
  private modelMoreClick() {
    this.page = this.page + 1;
    this.getList();
  }
  private emptyHandle() {
    this.searchForm = {
      item: '',
      name: ''
    };
    this.searchShow.isShow = false;
    this.$emit('isSearch', this.searchShow.isShow);
    this.selected = '';
  }
  private changeHandle(value: any) {
    this.$emit('isConfirm', value);
    this.searchShow.isShow = false;
    this.$emit('isSearch', this.searchShow.isShow);
    this.selected = '';
    this.modelMore = false;
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
